export function isLocalDevelopmentHost(hostname: string): boolean {
  return ['localhost', '127.0.0.1', '0.0.0.0'].includes(hostname);
}

export function isLocalDevelopmentEnvironment(nodeEnv: string, hostname: string): boolean {
  return nodeEnv === 'development' && isLocalDevelopmentHost(hostname);
}
